import * as React from "react";
import CircularProgress, {
  CircularProgressProps,
} from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

type Props = CircularProgressProps & {
  value: number;
  /** Optional explicit font size for the label (px). If omitted, we derive it from size. */
  labelFontSize?: number;
};

export function CircularProgressWithLabel({
  value,
  size = 40,
  thickness,
  labelFontSize,
  ...rest
}: Props) {
  const computedFontSize =
    labelFontSize ?? Math.round((Number(size) || 40) * 0.3);

  return (
    <Box
      sx={{
        position: "relative",
        display: "inline-flex",
        width: size,
        height: size,
      }}
    >
      <CircularProgress
        variant="determinate"
        size={size}
        thickness={thickness}
        value={value}
        {...rest}
      />
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)", // exact centering
          pointerEvents: "none",
          color: "text.secondary",
          fontSize: computedFontSize,
          lineHeight: 1,
          fontVariantNumeric: "tabular-nums",
          textAlign: "center",
          // If it still looks 1px low/high in your font, uncomment:
          // transform: "translate(-50%, calc(-50% - 1px))",
        }}
      >
        {`${Math.round(value)}%`}
      </Box>
    </Box>
  );
}
